<template>
  <div class="mb-1">
	<a class="card card-basic simple-favorites" :href="itemLink">
		<span class="card-label card-label-yellow card-label-floating">{{ item.entity }}</span>
		<img v-if="item.preview" class="card-media" :src="item.preview">
		<span class="card-details block p-2">
			<h5 class="card-title">{{ item.title }}</h5>
			<span class="card-date font-small">Added {{ item.liked_at | date }}</span>
		</span>
	</a>
  </div>
</template>

<script>
    import ListItem from '../mixins/base-list-item';

    export default{
    	mixins: [ListItem],

      	computed: {
    		lessonLink() {
				return '/lessons/' + this.item.slug + '/overview';
			},

			courseLink() {
    			return '/courses/' + this.item.slug;
			},

			itemLink() {
				if(this.item.entity === 'lesson') {
					return this.lessonLink;
				}
				if(this.item.entity === 'course') {
					return this.courseLink;
				}
			}
      	}
    }
</script>
